import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import formatTemplate from 'properties/style/color_thickness.ejs';
import util from 'util/Util.js';
import { pickerCfg } from 'pickerCfg.js';

class StyleSignatureColorAndThicknessView extends BasePropertyView {

    initialize(opts) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=number]': 'updateAttributes',
            'change input[type=text]': 'updateColorAttributesWithValidation',
            'change input[type=color]': 'updateColorAttributes',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus'
        };

        // Add needed property
        if (!this.model.get('signatureColor')) {
            this.model.set('signatureColor', '#000000', { silent: true });
        }
        if (!this.model.get('signatureThickness')) {
            this.model.set('signatureThickness', 3, { silent: true });
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    render() {
        super.render();

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();
        return this;
    }

}

export default StyleSignatureColorAndThicknessView;
